/**
 * Convert local date strings to UTC ISO boundaries for API date filtering.
 * This ensures date ranges work correctly regardless of user timezone.
 */
export function getDateFilterParams(dateFrom, dateTo) {
  const params = {};
  if (dateFrom) {
    params.date_from_utc = new Date(`${dateFrom}T00:00:00`).toISOString();
  }
  if (dateTo) {
    params.date_to_utc = new Date(`${dateTo}T23:59:59`).toISOString();
  }
  // Also send raw dates for backward compat
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  params.tz_offset = new Date().getTimezoneOffset();
  return params;
}

/**
 * Append date filter params to a URLSearchParams object.
 */
export function appendDateParams(searchParams, dateFrom, dateTo) {
  const p = getDateFilterParams(dateFrom, dateTo);
  Object.entries(p).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") searchParams.set(k, v);
  });
}
